import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

import "./dropzoneelement.scss";

function DropzoneElement(props) {
  const [files, setFiles] = useState([]);

  const handleDrop = (acceptedFiles) => {
    const fixedFiles = acceptedFiles.map((file) => {
      if (!file.type) {
        if (file.name.endsWith(".gltf")) {
          file = new File([file], file.name, { type: "model/gltf" });
        }
      }

      return Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
    });

    setFiles(fixedFiles);
    props.updateSelectedServiceFiles(fixedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: props.type,
    onDrop: handleDrop,
    multiple: props.mulitple ? props.multiple : true,
  });

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );
  return (
    <section
      className="dropzone-element"
      style={{ width: "70%", margin: "auto" }}
    >
      <div className="" {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        {/* <div className="placeh">
          {props.value
            ? props.value
            : "Drag 'n' drop some files here, or click to select files"}
        </div> */}
        <div className="placeh">
          {files.length > 0
            ? files[0].name
            : props.value
              ? props.value?.name || props.value?.split("/").pop()
              : "Drag 'n' drop some files here, or click to select files"}
        </div>
      </div>
    </section>
  );
}

<DropzoneElement />;

export default DropzoneElement;
